<template>
  <!-- <component :is="workersList === undefined || suppliersList === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="workersList === undefined">
      <h4 class="alert-heading">獲取審批師傅數據時出錯</h4>
      <div class="alert-body">
        找不到相關審批師傅記錄。請查看
        <b-link class="alert-link" :to="{ name: 'worker-list' }">
          審批師傅列表
        </b-link>
      </div>
    </b-alert>

    <b-alert variant="danger" :show="suppliersList === undefined">
      <h4 class="alert-heading">獲取審批供應商數據時出錯</h4>
      <div class="alert-body">
        找不到相關審批供應商記錄。請查看
        <b-link class="alert-link" :to="{ name: 'approval-expenditure-supplier-list' }">
          審批供應商列表
        </b-link>
      </div>
    </b-alert> -->
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-calculator" /> 審批薪金支出
    </h4>
    <b-tabs pills>
      <!-- Tab: worker -->
      <b-tab active>
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">師傅</span>
        </template>

        <progress-list :in_approve="true" class="" />
      </b-tab>
      <!-- Tab: supplier-->
      <b-tab v-if="false">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">服務供應商</span>
        </template>

        <suppliers-list class="" />
      </b-tab> -->
    </b-tabs>
  </b-card>
  <!-- </component> -->
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import progressList from "@/views/progress/progress-list/progressList.vue";
import suppliersList from "./supplier/suppliers-list/suppliersList.vue";

export default {
  components: {
    progressList,
    suppliersList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {},
};
</script>
